import React from "react";
import { Link } from "react-router-dom";
import PolicyLayout, { EmailLink } from "./PolicyLayout";

function Cookies() {
  return (
    <PolicyLayout
      title="cookie policy"
      intro="This page describes cookies and similar storage used by the tunrisefield website."
    >
      <h2>1. Current use on this store</h2>
      <p>
        The store currently uses browser <strong>local storage</strong> to remember the contents of
        your shopping cart. The saved record contains product identifiers and your selected quantity,
        size, and color. Local storage is similar to a cookie because information remains on your
        device, but it is not sent with every web request.
      </p>
      <div className="policy-callout">
        <p>
          We do not currently intend to place analytics or advertising cookies on the storefront.
          If optional tracking is added, we will update this notice and request consent where required.
        </p>
      </div>

      <h2>2. Essential technologies</h2>
      <p>
        Essential storage may be used to provide a feature you request, maintain security, prevent
        fraud, balance traffic, or remember a privacy choice. These technologies are not used to build
        an advertising profile.
      </p>

      <h2>3. External checkout</h2>
      <p>
        When you continue to the hosted payment page, the payment provider may use its own cookies or
        similar technologies for payment processing, authentication, security, and fraud prevention.
        Its notice and controls apply on that page.
      </p>

      <h2>4. Your controls</h2>
      <ul>
        <li>Remove this site’s data using your browser’s privacy or site-storage settings.</li>
        <li>Use private-browsing mode to limit persistent local storage on a shared device.</li>
        <li>Block cookies through browser settings; this may prevent checkout or security features from working.</li>
        <li>Remove saved cart data by clearing the cart or deleting this site’s local storage.</li>
      </ul>

      <h2>5. Privacy</h2>
      <p>
        For more information about related personal information, read our <Link to="/privacy">Privacy Policy</Link>
        and <Link to="/data-choices">Privacy Choices</Link> page.
      </p>

      <h2>6. Changes and contact</h2>
      <p>
        We may update this notice when the website’s storage practices change. Questions can be sent
        to <EmailLink subject="Cookie policy question" />.
      </p>
    </PolicyLayout>
  );
}

export default Cookies;
